import React from 'react';
import { Link } from 'react-router-dom'; // Import Link for SPA navigation
import { FaLinkedin } from 'react-icons/fa'; // Importing LinkedIn icon

const Footer = () => {
  return (
    <footer className="bg-blue-200 text-grey p-8 text-center mt-8 rounded-lg shadow-lg">
      <p className="text-xl font-bold mb-4">Dedicated to Protecting Your Digital Identity</p>
      <div className="flex justify-center items-center mb-4">
        <span className="bg-blue-600 p-3 rounded-full mr-3">🛡️</span>
        <span className="text-sm">Copyright © 2025, Deepfake Help. All rights reserved.</span>
      </div>
      <div className="flex flex-col md:flex-row justify-center md:space-x-8 space-y-4 md:space-y-0 mb-4">
        <Link to="/terms-and-conditions" className="hover:text-blue-300">Terms and Conditions</Link>
        <Link to="/privacy-policy" className="hover:text-blue-300">Privacy Policy</Link>
        <Link to="/about-us" className="hover:text-blue-300">About Us</Link>
        <Link to="/contact" className="hover:text-blue-300">Contact</Link>
        <a href="https://www.linkedin.com/company/deepfakehelp" className="flex items-center justify-center hover:text-blue-300" target="_blank" rel="noopener noreferrer">
          <FaLinkedin className="mr-1" /> LinkedIn
        </a>
      </div>
    </footer>
  );
};

export default Footer;
